import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import "../../../styles/Auth/employee.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import trayUpload from "@iconify/icons-mdi/tray-upload";
import { postData, uploadFile, getData, putData, deleteData } from "../../../webService/webservice.js";
const EmployeePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddEmployee = location.pathname === '/employees/add';
    const [searchQuery, setSearchQuery] = useState('');
    const [previewUrl, setPreviewUrl] = useState(null);
    const [IdPreviewUrl, setIdPreviewUrl] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [employeeImage, setEmployeeImage] = useState(null);
    const [IdProofImage, setIdProofImage] = useState(null);
    const [users, setUsers] = useState([]);
    const [open, setOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [employeeToDelete, setEmployeeToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const token = sessionStorage.getItem("sessionToken");
    const [isEditMode, setIsEditMode] = useState(false);
    const [editEmployeeId, setEditEmployeeId] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        role: '',
        phoneNumber: '',
        gender: '',
        employeeImageObject: '',
        password: '',
        confirmPassword: '',
        staffId: '',
        dateOfBirth: '',
        age: '',
        currentAddress: '',
        permanentAddress: '',
        bloodGroup: '',
        emergencyContactPerson: '',
        emergencyContactNumber: '',
        idProoftype: '',
        idProofNumber: '',
        idProofDocument: '',
    });


    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const validatePhone = (phone) =>
    /^[6-9]\d{9}$/.test(phone); // Indian mobile

    const validatePassword = (password) =>
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/.test(password);
    // min 8 chars, 1 letter, 1 number

    const validateForm = () => {
        const newErrors = {};

        // REQUIRED FIELDS
        if (!formData.name?.trim()) {
            newErrors.name = "Name is required";
        }

        if (!formData.email?.trim()) {
            newErrors.email = "Email is required";
        } else if (!validateEmail(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!formData.phoneNumber) {
            newErrors.phoneNumber = "Phone number is required";
        } else if (!validatePhone(formData.phoneNumber)) {
            newErrors.phoneNumber = "Invalid mobile number";
        }

        if (!formData.role) {
            newErrors.role = "Role is required";
        }

        if (!formData.gender) {
            newErrors.gender = "Gender is required";
        }

        if (!formData.password) {
            newErrors.password = "Password is required";
        } else if (!validatePassword(formData.password)) {
            newErrors.password =
            "Password must be at least 8 characters and contain letters & numbers";
        }

        if (!formData.confirmPassword) {
            newErrors.confirmPassword = "Confirm password is required";
        } else if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }

        if (!formData.idProoftype) {
            newErrors.idProoftype = "ID proof type is required";
        }

        // ID PROOF NUMBER ✅ NEW
        if (!formData.idProofNumber) {
            newErrors.idProofNumber = "ID proof number is required";
        } else if (
            formData.idProoftype &&
            !validateIdProof(formData.idProoftype, formData.idProofNumber)
        ) {
            newErrors.idProofNumber = `Invalid ${formData.idProoftype} format`;
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleEmailChange = (e) => {
        const email = e.target.value;
        setFormData((prev) => ({ ...prev, email }));

        if (!validateEmail(email)) {
            setEmailError("Please enter a valid email address");
        } else {
            setEmailError("");
        }
    };

    const handleAddEmployee = async (e) => {

        e.preventDefault();

        if (!validateForm()) return;
        try {
            const sessionToken = sessionStorage.getItem("sessionToken");
            const userId = sessionStorage.getItem("userId");

            // ✅ Validate ID Proof
            if(formData.idProoftype) {
                if (!validateIdProof(formData.idProoftype, formData.idProofNumber)) {
                    alert(`Please enter a valid ${formData.idProoftype} number`);
                    return;
                }
            }            
            let uploadResult;
            if ((!employeeImage || !IdProofImage) && userId) {
                // ✅ Upload employee & ID proof images
                uploadResult = await uploadFile(`files/upload/${userId}`, employeeImage, IdProofImage);
            } else {
                toast.error(uploadResult?.message || "Image upload failed");
            }

            // ✅ Build payload for backend
            const employeeData = {
                name: formData.name,
                email: formData.email,
                gender: formData.gender,
                role: formData.role,
                phoneNumber: formData.phoneNumber,
                employeeImageObject: uploadResult?.data,
                staffId: formData.staffId,
                password: formData.password,
                dateOfBirth: formData.dateOfBirth,
                age: formData.age,
                currentAddress: formData.currentAddress,
                permanentAddress: formData.permanentAddress,
                bloodGroup: formData.bloodGroup,
                emergencyContactPerson: formData.emergencyContactPerson,
                emergencyContactNumber: formData.emergencyContactNumber,
                idProoftype: formData.idProoftype,
                idProofNumber: formData.idProofNumber,
                idProofDocument: uploadResult?.data,
            };

            console.log("Sending employee data:", employeeData);
            // ✅ Post to backend
            const response = await postData("users/signup", employeeData, sessionToken);

            if (response?.status === 200) {
                toast.success(response.message || "Employee added successfully");

                // ✅ Reset form after success
                setFormData({
                    name: "",
                    email: "",
                    phoneNumber: "",
                    role: "",
                    gender: "",
                    employeeImageObject: "",
                    staffId: "",
                    password: "",
                    confirmPassword: "",
                    dateOfBirth: "",
                    age: "",
                    currentAddress: "",
                    permanentAddress: "",
                    bloodGroup: "",
                    emergencyContactPerson: "",
                    emergencyContactNumber: "",
                    idProoftype: "",
                    idProofNumber: "",
                    idProofDocument: "",
                });
                setEmployeeImage(null);
                setIdProofImage(null);
                setPreviewUrl(null);

                navigate("/employees");
                triggerRefresh();
            } else {
                toast.error(response?.message || "Failed to add employee");
            }
        } catch (error) {
            console.error("Add Employee Error:", error);
            toast.error(error.message || "Add Employee Failed");
        }
    };

    useEffect(() => {
        fetchEmployees(currentPage, limit, searchQuery, token);
    }, [currentPage, limit, refreshKey, searchQuery, token]);

    const fetchEmployees = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            search: searchQuery?.trim() || "",
        }
        try {
            setLoading(true);
            const response = await getData('users/users', params, token);
            const resultsWrapper = response?.data?.[0];
            const employeeList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setUsers(employeeList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch categories");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateEmployee = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        try {
            const token = sessionStorage.getItem("Token");
            const userId = sessionStorage.getItem("userId");

            let updatedImageObject = formData.employeeImageObject;

            if (employeeImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, employeeImage);

                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }
            const updatedEmployeeData = {
                name: formData.name,
                email: formData.email,
                phoneNumber: formData.phoneNumber,
                role: formData.role,
                gender: formData.gender,
                employeeImageObject: updatedImageObject,
                staffId: formData.staffId,
                password: formData.password,
                confirmPassword: formData.confirmPassword,
                dateOfBirth: formData.dateOfBirth,
                age: formData.age,
                currentAddress: formData.currentAddress,
                permanentAddress: formData.permanentAddress,
                bloodGroup: formData.bloodGroup,
                emergencyContactPerson: formData.emergencyContactPerson,
                emergencyContactNumber: formData.emergencyContactNumber,
                idProoftype: formData.idProoftype,
                idProofNumber: formData.idProofNumber,
                idProofDocument: formData.idProofDocument,
            };

            console.log("Updating Employee with data:", updatedEmployeeData);

            const response = await putData(`users/user/${editEmployeeId}`, updatedEmployeeData, token);

            toast.success(response.message || 'Employee updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                name: '',
                email: '',
                phoneNumber: '',
                role: '',
                gender: '',
                employeeImageObject: '',
                staffId: '',
                password: '',
                confirmPassword: '',
                dateOfBirth: '',
                age: '',
                currentAddress: '',
                permanentAddress: '',
                bloodGroup: '',
                emergencyContactPerson: '',
                emergencyContactNumber: '',
                idProoftype: '',
                idProofNumber: '',
                idProofDocument: '',
            });
            setEmployeeImage(null);
            setPreviewUrl(null);
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchEmployees(currentPage, limit);
            triggerRefresh();
        } catch (error) {
            toast.error("Error updating employee.");
        }
    }
    const handleDeleteEmployee = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('Token');
            const response = await deleteData(`users/user/${employeeToDelete}`, token);
            toast.success(response.message || "Employee deleted successfully");
            setEmployeeToDelete(null);
            fetchEmployees(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Employee");
        }
    }
    const handleOpen = (employeeId) => {
        setEmployeeToDelete(employeeId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setEmployeeToDelete(null);
    };

    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Image',
        'Name',
        'Email',
        'Phone Number',
        'Action',
    ];

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const handleChange = e => {
        const { name, value } = e.target;
        // For firstName and lastName: only alphabets, no spaces
        if ((name === 'firstName' || name === 'lastName')) {

            if (/[^a-zA-Z]/.test(value)) return;

            const capitalizedValue =
                value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

            setFormData((prev) => ({
                ...prev,
                [name]: capitalizedValue,
            }));
            return;
        }

        if (name === 'confirmPassword' || name === 'password') {
            const newPassword = name === 'password' ? value : formData.password;
            const newConfirm = name === 'confirmPassword' ? value : formData.confirmPassword;

            if (newPassword && newConfirm && newPassword !== newConfirm) {
                setPasswordMatchError('Passwords do not match');
            } else {
                setPasswordMatchError('');
            }
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    function calculateAge(dob) {
        if (!dob) return "";
        const today = new Date();
        const birthDate = new Date(dob);

        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    const validateIdProof = (type, value) => {
        if (!type || !value) return false;

        const patterns = {
            Aadhaar: /^\d{12}$/,
            "PAN CARD": /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            "Voter ID": /^[A-Z]{3}[0-9]{7}$/,
            "Ration Card": /^[A-Z0-9]{8,12}$/
        };

        return patterns[type]?.test(value) || false;
    };

    return (
        <div className="employee-layout">
            <div className="employee-content">
                <main className="employee-main">
                    {isAddEmployee ? (
                        <div className="add-employee-form">
                            <h3>Add Employee</h3>
                            <form className="employee-form" onSubmit={handleAddEmployee}>
                                <div className="employee-form-row">
                                    <div className="employee-form-group-image">
                                        <div className="image-upload-wrapper">
                                            <div className="image-placeholder">
                                                <img
                                                    src={previewUrl || '/assets/mdi--user.svg'}
                                                    alt="Preview"
                                                    className="round-image"
                                                />
                                            </div>
                                        </div>
                                        <div className="upload-icon-container">
                                            <label htmlFor="employeeImage" className="upload-icon-btn">
                                                Upload Image
                                                <Icon icon={trayUpload} width="24" height="24" />
                                                <input
                                                    type="file"
                                                    id="employeeImage"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        setEmployeeImage(file);
                                                        setPreviewUrl(URL.createObjectURL(file));
                                                    }}
                                                />

                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label htmlFor="name" className="input-label">
                                            Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter employee name"
                                            className="category-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                            }
                                        />
                                        {errors.name && <p className="error-msg">{errors.name}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="email" className="input-label">
                                            Email<span className="required">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            className="category-input"
                                            placeholder="Enter Email"
                                            onChange={handleEmailChange}
                                        />
                                        {errors.email && <p className="error-msg">{errors.email}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="phoneNumber" className="input-label">Mobile Number<span className="required">*</span></label>
                                
                                        <input
                                            type="text"
                                            className="category-input"
                                            placeholder="Enter Mobile Number"
                                            maxLength={10}
                                            title="Mobile Number must be exactly 10 digits"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                }
                                            }}
                                        />
                                        {errors.phoneNumber && (
                                            <p className="error-msg">{errors.phoneNumber}</p>
                                        )}

                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="role" className="input-label">Role<span className="required">*</span></label>
                                        <select
                                            id="role"
                                            className="category-input"
                                            required
                                            onChange={(e) => {
                                                const selectedRole = e.target.value;
                                                setFormData((prev) => ({ ...prev, role: selectedRole }))
                                            }}
                                        >
                                            <option value='' >Select Role</option>
                                            <option value='SuperAdmin'>SuperAdmin</option>
                                            <option value='Admin'>Admin</option>
                                            <option value='Biller'>Biller</option>
                                        </select>
                                        {errors.role && <p className="error-msg">{errors.role}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="dateOfBirth" className="input-label">
                                            Date-Of-Birth
                                        </label>
                                        <input
                                            name="dateOfBirth"
                                            placeholder="enter Date Of Birth"
                                            type="date"
                                            className="department-input"
                                            onChange={(e) => {
                                                const dob = e.target.value;
                                                const age = calculateAge(dob);

                                                setFormData({
                                                    ...formData,
                                                    dateOfBirth: dob,
                                                    age: age
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="age" className="input-label">
                                            Age
                                        </label>
                                        <input
                                            type="number"
                                            className="department-input"
                                            readOnly
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="bloodGroup" className="input-label">
                                            Blood Group
                                        </label>
                                        <input
                                            name="bloodGroup"
                                            placeholder="Enter Blood Group"
                                            type="text"
                                            className="department-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, bloodGroup: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="gender" className="input-label">
                                            Gender<span className="required">*</span>
                                        </label>
                                        <select
                                            id="gender"
                                            className="category-input"
                                            placeholder="Select Gender"
                                            onChange={(e) => {
                                                const selectedgendertype = e.target.value;
                                                setFormData((prev) => ({ ...prev, gender: selectedgendertype }))
                                            }}
                                        >
                                            <option value='' >Select Gender</option>
                                            <option value='Male'>Male</option>
                                            <option value='Female'>Female</option>
                                            <option value='Other'>Other</option>
                                        </select>
                                        {errors.gender && (
                                            <p className="error-msg">{errors.gender}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="employee-form-row">
                                    <div className="employee-form-group">
                                        <label htmlFor="password" className="input-label">
                                            Password<span className="required">*</span>
                                        </label>
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            placeholder="Password"
                                            onChange={handleChange}
                                            className="department-input"
                                            required
                                        />
                                        <span className="emp-signup-show" onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                        {errors.password && (
                                            <p className="error-msg">{errors.password}</p>
                                        )}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="password" className="input-label">
                                            Confirm Password<span className="required">*</span>
                                        </label>
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            name="confirmPassword"
                                            placeholder="Confirm Password"
                                            onChange={handleChange}
                                            className="department-input"
                                            required
                                        />
                                        <span className="emp-signup-show" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                        {errors.password && (
                                            <p className="error-msg">{errors.password}</p>
                                        )}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="idProoftype" className="input-label">
                                            ID Proof Type<span className="required">*</span>
                                        </label>
                                        <select
                                            id="idProoftype"
                                            className="category-input"
                                            placeholder="Select idProoftype"
                                            onChange={(e) => {
                                                const selectedidProoftypetype = e.target.value;
                                                setFormData((prev) => ({ ...prev, idProoftype: selectedidProoftypetype }))
                                            }}
                                        >
                                            <option value='' >Select idProoftype</option>
                                            <option value='Ration Card'>Ration Card</option>
                                            <option value='Voter ID'>Voter ID</option>
                                            <option value='Aadhaar'>Aadhaar</option>
                                            <option value='PAN CARD'>PAN CARD</option>
                                        </select>
                                        {errors.idProoftype && <p className="error-msg">{errors.idProoftype}</p>}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="idProofNumber" className="input-label">
                                            ID Proof Number<span className="required">*</span>
                                        </label>
                                        <input
                                            id="idProofNumber"
                                            type="text"
                                            className="category-input"
                                            placeholder="Enter ID Proof Number"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setFormData((prev) => ({ ...prev, idProofNumber: value }));

                                                // validate live
                                                if (formData.idProoftype) {
                                                    const isValid = validateIdProof(formData.idProoftype, value);
                                                    setFormData((prev) => ({ ...prev, idProofValid: isValid }));
                                                }
                                            }}
                                        />
                                        {errors.idProofNumber && (
                                            <p className="error-msg">{errors.idProofNumber}</p>
                                        )}
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="idProofDocument" className="input-label">
                                            Id Proof Document
                                        </label>
                                        <input
                                            name="idProofDocument"
                                            placeholder="Upload idProofDocument"
                                            type="file"
                                            accept="image/*"
                                            className="department-input"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setIdProofImage(file);
                                                setIdPreviewUrl(URL.createObjectURL(file));
                                            }}
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="emergencyContactNumber" className="input-label">
                                            Emergency Contact Number
                                        </label>
                                        <input
                                            name="emergencyContactNumber"
                                            placeholder="Enter Contact number"
                                            type="text"
                                            className="department-input"
                                            maxLength={10}
                                            title="Mobile Number must be exactly 10 digits"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, emergencyContactNumber: value }));
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="currentAddress" className="input-label">
                                            Current Address
                                        </label>
                                        <input
                                            name="currentAddress"
                                            placeholder="Enter Current Address"
                                            type="text"
                                            className="department-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, currentAddress: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="employee-form-group">
                                        <label htmlFor="permanentAddress" className="input-label">
                                            Permanent Address
                                        </label>
                                        <input
                                            name="permanentAddress"
                                            placeholder="Enter Permanent Address"
                                            type="text"
                                            className="department-input"
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, permanentAddress: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="employee-buttons">
                                    <button className="add-employee-button" type="submit" disabled={emailError !== ""} onClick={isAddEmployee ? handleAddEmployee : handleUpdateEmployee}>
                                        {isEditMode ? "Update employee" : "Add employee"}
                                    </button>
                                    <button className="cancel-employee-button" onClick={() => navigate('/employees')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div >
                    ) : (
                        <>
                            <div className="employee-widgets">
                                <div className="employee-widgets-header">
                                    <h3>Employees</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="employee-search-input"
                                        name="search"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="employee-actions">

                                    <button className="add-btn-employee" onClick={() => navigate('/employees/add')}>
                                        + Add New
                                    </button>

                                </div>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-employee-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-employee-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {users.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No Users found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            users.map((user, index) => (
                                                <TableRow key={user._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                            <img
                                                                src={
                                                                    user.employeeImageObject?.uri
                                                                        ? `${process.env.REACT_APP_API_URL}${user.employeeImageObject.uri}`
                                                                        : "/assets/management-consulting.png"
                                                                }
                                                                alt={user.name}
                                                                style={{ width: 40, height: 40, borderRadius: '4px' }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{user.name || user.firstName}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{user.email}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{user.phoneNumber}</Typography></TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            {/* <Icon icon={plusIcon} width={20} height={20} /> */}
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    name: user.name || '',
                                                                    email: user.email || '',
                                                                    role: user.role || '',
                                                                    phoneNumber: user.phoneNumber || '',
                                                                    gender: user.gender || '',
                                                                    employeeImageObject: user.employeeImageObject || '',
                                                                    dateOfBirth: user.dateOfBirth || '',
                                                                    age: user.age || '',
                                                                    currentAddress: user.currentAddress || '',
                                                                    permanentAddress: user.permanentAddress || '',
                                                                    bloodGroup: user.bloodGroup || '',
                                                                    emergencyContactPerson: user.emergencyContactPerson || '',
                                                                    emergencyContactNumber: user.emergencyContactNumber || '',
                                                                    idProoftype: user.idProoftype || '',
                                                                    idProofNumber: user.idProofNumber || '',
                                                                    idProofDocument: user.idProofDocument || '',
                                                                });
                                                                setPreviewUrl(
                                                                    user?.employeeImageObject?.uri
                                                                        ? `${process.env.REACT_APP_API_URL}${user.employeeImageObject.uri}`
                                                                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                );
                                                                setIdPreviewUrl(user.idProofDocument || '');
                                                                setEmployeeImage(null);
                                                                setEditEmployeeId(user._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: 'pointer' }}
                                                                onClick={() => handleOpen(user._id)}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="product-bottom">
                                <div className="product-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="product-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="product-section spacer"></div>
                                <div className="product-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    name: '',
                                                    email: '',
                                                    role: '',
                                                    phoneNumber: '',
                                                    employeeImageObject: null,
                                                    password: '',
                                                    age: '',
                                                    dateOfBirth: '',
                                                    currentAddress: '',
                                                    permanentAddress: '',
                                                    bloodGroup: '',
                                                    emergencyContactPerson: '',
                                                    emergencyContactNumber: '',
                                                    idProoftype: '',
                                                    idProofNumber: '',
                                                    idProofDocument: '',
                                                });
                                                setPreviewUrl(null);
                                            }}
                                        />
                                        <div className="popup-form-Employee">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Employee" : "Add Employee"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateEmployee}>
                                                <div className="form-group-row">
                                                    <div className="employee-form-group-image">
                                                        <div className="image-upload-wrapper">
                                                            <div className="image-placeholder">
                                                                <img
                                                                    src={previewUrl || '/assets/mdi--user.svg'}
                                                                    alt="Preview"
                                                                    className="round-image"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="upload-icon-container">
                                                            <label htmlFor="employeeImage" className="upload-icon-btn">
                                                                Upload Image
                                                                <Icon icon={trayUpload} width="24" height="24" />
                                                                <input
                                                                    type="file"
                                                                    id="employeeImage"
                                                                    accept="image/*"
                                                                    style={{ display: 'none' }}
                                                                    onChange={(e) => {
                                                                        const file = e.target.files[0];
                                                                        setEmployeeImage(file);
                                                                        setPreviewUrl(URL.createObjectURL(file));
                                                                    }}
                                                                />
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="name" className="input-label">
                                                            Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter employee name"
                                                            className="category-input"
                                                            value={formData.name}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="role" className="input-label">Role</label>
                                                        <select
                                                            id="role"
                                                            className="category-input"
                                                            required
                                                            value={formData.role}
                                                            onChange={(e) => {
                                                                const selectedRole = e.target.value;
                                                                setFormData((prev) => ({ ...prev, role: selectedRole, departmentId: "" }));
                                                                // reset department if role changes
                                                            }}
                                                        >
                                                            <option value=''>Select Role</option>
                                                            <option value='SuperAdmin'>SuperAdmin</option>
                                                            <option value='Admin'>Admin</option>
                                                            <option value='Biller'>Biller</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="phoneNumber" className="input-label">Mobile Number</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            placeholder="Enter Mobile Number"
                                                            maxLength={12}
                                                            title="Mobile Number must be exactly 12 digits"
                                                            value={formData.phoneNumber}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Allow only digits and max 12 characters
                                                                if (/^\d{0,10}$/.test(value)) {
                                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="email" className="input-label">
                                                            Email
                                                        </label>
                                                        <input
                                                            type="email"
                                                            className="category-input"
                                                            placeholder="Enter Email"
                                                            value={formData.email || ""}
                                                            onChange={handleEmailChange}
                                                        />
                                                        {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="gender" className="input-label">
                                                            Gender
                                                        </label>
                                                        <select
                                                            id="gender"
                                                            className="category-input"
                                                            placeholder="Select Gender"
                                                            value={formData.gender}
                                                            onChange={(e) => {
                                                                const selectedgendertype = e.target.value;
                                                                setFormData((prev) => ({ ...prev, gender: selectedgendertype }))
                                                            }}
                                                        >
                                                            <option value='' >Select Gender</option>
                                                            <option value='Male'>Male</option>
                                                            <option value='Female'>Female</option>
                                                            <option value='Other'>Other</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="password" className="input-label">
                                                            Password
                                                        </label>
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            name="password"
                                                            placeholder="Password"
                                                            value={formData.password}
                                                            onChange={handleChange}
                                                            className="department-input"
                                                        />
                                                        <span className="signup-show" onClick={() => setShowPassword(!showPassword)}>
                                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                        </span>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="password" className="input-label">
                                                            Confirm Password
                                                        </label>
                                                        <input
                                                            type={showConfirmPassword ? "text" : "password"}
                                                            name="confirmPassword"
                                                            placeholder="Confirm Password"
                                                            value={formData.confirmPassword}
                                                            onChange={handleChange}
                                                            className="department-input"

                                                        />
                                                        <span className="signup-show" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                        </span>

                                                        {passwordMatchError && <p className="password-error-msg">{passwordMatchError}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="dateOfBirth" className="input-label">
                                                            Date-Of-Birth
                                                        </label>
                                                        <input
                                                            name="dateOfBirth"
                                                            placeholder="enter Date Of Birth"
                                                            type="datetime-local"
                                                            className="department-input"
                                                            value={formData.endTime ? formData.endTime.toISOString().slice(0, 16) : ''}
                                                            onChange={(e) => {
                                                                const dob = e.target.value;
                                                                const age = calculateAge(dob);

                                                                setFormData({
                                                                    ...formData,
                                                                    dateOfBirth: dob,
                                                                    age: age
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="age" className="input-label">
                                                            Age
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="department-input"
                                                            value={formData.age || ""}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="bloodGroup" className="input-label">
                                                            Blood Group
                                                        </label>
                                                        <input
                                                            name="bloodGroup"
                                                            placeholder="Enter Blood Group"
                                                            type="text"
                                                            className="department-input"
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, bloodGroup: e.target.value }))
                                                            }
                                                            value={formData.bloodGroup}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="idProoftype" className="input-label">
                                                            ID Proof Type
                                                        </label>
                                                        <select
                                                            id="idProoftype"
                                                            className="category-input"
                                                            placeholder="Select idProoftype"
                                                            value={formData.idProoftype}
                                                            onChange={(e) => {
                                                                const selectedidProoftypetype = e.target.value;
                                                                setFormData((prev) => ({ ...prev, idProoftype: selectedidProoftypetype }))
                                                            }}
                                                        >
                                                            <option value='' >Select idProoftype</option>
                                                            <option value='Ration Card'>Ration Card</option>
                                                            <option value='Voter ID'>Voter ID</option>
                                                            <option value='Aadhaar'>Aadhaar</option>
                                                            <option value='PAN CARD'>PAN CARD</option>
                                                        </select>
                                                    </div>

                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="idProofNumber" className="input-label">
                                                            ID Proof Number
                                                        </label>
                                                        <input
                                                            id="idProofNumber"
                                                            type="text"
                                                            className="category-input"
                                                            placeholder="Enter ID Proof Number"
                                                            value={formData.idProofNumber || ""}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setFormData((prev) => ({ ...prev, idProofNumber: value }));

                                                                // validate live
                                                                if (formData.idProoftype) {
                                                                    const isValid = validateIdProof(formData.idProoftype, value);
                                                                    setFormData((prev) => ({ ...prev, idProofValid: isValid }));
                                                                }
                                                            }}
                                                        />

                                                        {/* Show validation message */}
                                                        {formData.idProofNumber && formData.idProoftype && !formData.idProofValid && (
                                                            <span style={{ color: "red", fontSize: "12px" }}>
                                                                Invalid {formData.idProoftype} number format
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="idProofDocument" className="input-label">
                                                            Id Proof Document
                                                        </label>
                                                        <input
                                                            name="idProofDocument"
                                                            placeholder="Upload idProofDocument"
                                                            type="file"
                                                            accept="image/*"
                                                            className="department-input"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                setIdProofImage(file);
                                                                setIdPreviewUrl(URL.createObjectURL(file));
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="emergencyContactNumber" className="input-label">
                                                            Emergency Contact Number
                                                        </label>
                                                        <input
                                                            name="emergencyContactNumber"
                                                            placeholder="Enter Contact number"
                                                            type="text"
                                                            className="department-input"
                                                            maxLength={10}
                                                            title="Mobile Number must be exactly 10 digits"
                                                            value={formData.emergencyContactNumber}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Allow only digits and max 10 characters
                                                                if (/^\d{0,10}$/.test(value)) {
                                                                    setFormData((prev) => ({ ...prev, emergencyContactNumber: value }));
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="currentAddress" className="input-label">
                                                            Current Address
                                                        </label>
                                                        <input
                                                            name="currentAddress"
                                                            placeholder="Enter Current Address"
                                                            type="text"
                                                            className="department-input"
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, currentAddress: e.target.value }))
                                                            }
                                                            value={formData.currentAddress}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="permanentAddress" className="input-label">
                                                            Permanent Address
                                                        </label>
                                                        <input
                                                            name="permanentAddress"
                                                            placeholder="Enter Permanent Address"
                                                            type="text"
                                                            className="department-input"
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, permanentAddress: e.target.value }))
                                                            }
                                                            value={formData.permanentAddress}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update Product" : "Add Product"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && users.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Employees
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this Employee?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: 'linear-gradient(#A16A70, #D98484)' }} onClick={handleDeleteEmployee}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )}
                </main >
            </div >

        </div >
    );
};


export default EmployeePage;